import { List, ListItem } from '@sainsburys-tech/luna-list'
import { TextButton } from '@sainsburys-tech/luna-button'

import { FC } from 'react'
import { IStore } from '../../types/IStore'
import { IDetails } from '../../types/IStoreDetails'

interface StoreDisplayProps{
  storeDetail : IDetails
   index:number
   currentStore: IStore
   changeStore:(store: any) => void
}

const StoreDisplay :FC<StoreDisplayProps>= ({storeDetail, index, currentStore,changeStore} ) => {

  const selectedIcon =
    !!currentStore && currentStore.storeCode === storeDetail.Id ? <span>✓</span> : ''

    const selectNewStore = (storeSelected:any)  => {
      changeStore(storeSelected)
      
    }

  return (
    <List
      key={index}
      type="bare"
      spaced
      className="ln-u-display-flex@md c-preview__list"
    >
      <ListItem>
        <TextButton
          id={`store-select-${storeDetail.Id}`}
          className="text__button"
          color="dark"
          fullWidth
          onClick={() => selectNewStore(storeDetail)}
        >
          {selectedIcon}
          <span className="displayName">
            {storeDetail.name} ({storeDetail.code ?? storeDetail.argos_code ?? storeDetail.myhr_code})
          </span>
        </TextButton>
      </ListItem>
    </List>
  )
}

export default StoreDisplay
